document.addEventListener('DOMContentLoaded', () => {
  const pillsContainer = document.querySelector('[data-collection-pills]');

  if (!pillsContainer) return;

  pillsContainer.addEventListener('click', (event) => {
    const pill = event.target.closest('[data-collection-pill]');

    if (!pill) return;

    // Allow normal browser behavior for:
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }

    if (typeof FacetFiltersForm === 'undefined') {
      return;
    }

    event.preventDefault();

    const collectionUrl = pill.dataset.collectionUrl;
    if (!collectionUrl) return;
    const url = new URL(collectionUrl, window.location.origin);

    // Don't carry existing filters when switching collection.
    const searchParams = '';

    // Update active pill immediately.
    pillsContainer
      .querySelectorAll('[data-collection-pill]')
      .forEach((item) => {
        item.classList.remove(
          'bg-[var(--color-brand)]',
          'text-[var(--color-surface)]',
          'border-[var(--color-brand)]'
        );

        item.classList.add('border-[var(--color-brand-dark)]');

        item.removeAttribute('aria-current');
      });

    pill.classList.remove('border-[var(--color-brand-dark)]');

    pill.classList.add(
      'bg-[var(--color-brand)]',
      'text-[var(--color-surface)]',
      'border-[var(--color-brand)]'
    );

    pill.setAttribute('aria-current', 'page');

    // Use the existing AJAX grid renderer.
    FacetFiltersForm.renderPage(
      searchParams,
      event,
      true,
      url.pathname
    );
  });
});